import { NgModule } from '@angular/core';
import { CompatABTestComponent } from './compat-abtest.component';

@NgModule({
  declarations: [CompatABTestComponent],
  entryComponents: [CompatABTestComponent],
})
export class CompatABTestModule {}



// WEBPACK FOOTER //
// ./src/compat/compat-abtest.module.ts